module.exports = __webpack_public_path__ + "img/0Q3A5468_FoamcoreMatted.c6c2a534.jpg";